/**
 * Coach hook — Inea's daily briefing (Module Coach).
 */
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiRequest } from '@/lib/api';

export type ActionType = 'prospect' | 'content' | 'audit' | 'follow_up';

export interface BriefingAction {
  type: ActionType;
  title: string;
  detail: string;
  link?: string;
  prospect_id?: string;
  idea?: string;
}

export interface DailyBriefing {
  briefing_day: string;
  greeting: string;
  energy: string;
  actions: BriefingAction[];
}

export function useCoach() {
  const qc = useQueryClient();

  const query = useQuery<DailyBriefing>({
    queryKey: ['coach', 'today'],
    queryFn: () => apiRequest<DailyBriefing>('/coach/today'),
    // Cached daily on the server — no need to refetch aggressively client-side.
    staleTime: 10 * 60_000,
  });

  const regenerate = useMutation({
    mutationFn: () => apiRequest<DailyBriefing>('/coach/regenerate', { method: 'POST' }),
    onSuccess: (b) => qc.setQueryData(['coach', 'today'], b),
  });

  return {
    briefing: query.data ?? null,
    isLoading: query.isLoading,
    regenerate,
  };
}
